import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { CommunicationSetting } from "models";

type PDFTemplate = {
  id: number;
  name: string;
  dealer_id: number | null;
  created_on: string;
  updated_on: string;
  description: string;
  is_previewable: boolean;
};

const component = "CommunicationSettings";

export const CommunicationSettingsQueryKeys = {
  settings: backendQueryKey<CommunicationSetting>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/communication/settings/read" }),
  pdfTemplates: backendQueryKey<PDFTemplate[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/report_templates/comm/list" })
};
